import {
  LoadingState,
  SET_AUTH_LOADING,
  LoadingActionTypes,
  AUTH_LOADING_SUCCESS,
  AUTH_LOADING_ERROR,
  SET_API_LOADING,
  API_LOADING_SUCCESS,
  API_LOADING_ERROR,
  SET_LOADING_SPINNER,
  SET_LOADING_PERCENT
} from './types';

const initialState: LoadingState = {
  authLoading: false,
  apiCallsInProgress: 0,
  loadingSpinner: false,
  loadingPercent: 0.0
};

const loadingReducer = (
  state: LoadingState = initialState,
  action: LoadingActionTypes
): LoadingState => {
  switch (action.type) {
    case SET_AUTH_LOADING:
      return {
        ...state,
        authLoading: true
      };
    case AUTH_LOADING_SUCCESS:
    case AUTH_LOADING_ERROR:
      return {
        ...state,
        authLoading: false
      };
    case SET_API_LOADING:
      return {
        ...state,
        apiCallsInProgress: state.apiCallsInProgress + 1
      };
    case API_LOADING_SUCCESS:
    case API_LOADING_ERROR:
      return {
        ...state,
        apiCallsInProgress: state.apiCallsInProgress - 1
      };
    case SET_LOADING_SPINNER:
      return { ...state, loadingSpinner: action.status };
    case SET_LOADING_PERCENT:
      return { ...state, loadingPercent: action.percent };
    default:
      return state;
  }
};

export default loadingReducer;
